import $ from "jquery";

//npm install photoswipe
//npm install photoswipe-dynamic-caption-plugin
import PhotoSwipeLightbox from 'photoswipe/lightbox';
//import PhotoSwipeDynamicCaption from 'photoswipe-dynamic-caption-plugin';
import PhotoSwipe from 'photoswipe';
import 'photoswipe/style.css';
//import 'photoswipe-dynamic-caption-plugin/photoswipe-dynamic-caption-plugin.css';
import PhotoSwipeVideoPlugin from '../libraries/photoswipe-video-plugin.esm.js';

$(function() {
    $(".showmedialightbox").on("click", function() {
        const $mediaSourceRoot = $(this).closest(".item, .cblock");
        showLightbox($mediaSourceRoot);
    });
});

function showLightbox($mediaSourceRoot) {
    const mediaList = [];

    $mediaSourceRoot.find(".lbmediasource").each(function() {
        const $mediasource = $(this);
        const videoUrl = $mediasource.data("video");
        const imageUrl = $mediasource.data("image");
        const isVideo = !!videoUrl; //videoUrl contains a value (is not "nullish")

        const mediaInfo = {};
        if(isVideo) {
            mediaInfo.videoSrc = videoUrl;
            mediaInfo.type = 'video';
        } else {
            mediaInfo.src = imageUrl;
            mediaInfo.width = parseInt($mediasource.data("image-width"));
            mediaInfo.height = parseInt($mediasource.data("image-height"));
        }
        mediaList.push(mediaInfo);
    });

    console.log(mediaList);

    const lightbox = new PhotoSwipe({
        showHideAnimationType: 'fade', //'zoom' / 'fade' / 'none'
        //showHideOpacity:true, //does not work
        //getThumbBoundsFn:false,
        //pswpModule: () => import('photoswipe'),
        pswpModule: PhotoSwipe,
        paddingFn: (viewportSize) => {
            return {
              top: 15, bottom: 15, left: 15, right: 15
            }
        },
        bgOpacity: 0.9,
        dataSource: mediaList,
        index: 0 //start slide index
    });
    /*const captionPlugin = new PhotoSwipeDynamicCaption(lightbox, {
        type: 'below'
    });*/
    const videoPlugin = new PhotoSwipeVideoPlugin(lightbox, {
    });
    lightbox.init();
}